import { appConfig } from '@common/config/app.config';
import { UploadedAttachment } from '@common-components/ai-chat/attachments';

/**
 * Task 7 — the one upload call every AI chat surface (btgpt, the agent
 * builder) uses to turn a picked `File` into an `UploadedAttachment`
 * (`AiChatAttachmentsOptions.upload`). A plain `fetch` multipart POST rather
 * than an RTK mutation: the shared `baseQueryWithReauth` forces
 * `Content-Type: application/json` on every request (backend-api.ts
 * `prepareHeaders`), which would corrupt a `FormData` body.
 *
 * The client gets back only `{ uploadId, name, mime, size }` — never a signed
 * URL (global-constraints: uploads live in the private MCP bucket).
 */
export async function uploadAiChatAttachment(file: File, token: string | null | undefined): Promise<UploadedAttachment> {
  const form = new FormData();
  form.append('file', file);
  const headers: HeadersInit = {};
  if (token) (headers as Record<string, string>).Authorization = `Bearer ${token}`;

  const res = await fetch(`${appConfig.API_ENDPOINT}/ai-chat/uploads`, {
    method: 'POST',
    headers,
    body: form,
  });

  if (!res.ok) {
    let message = `Upload failed (${res.status})`;
    try {
      const body = await res.json();
      if (body?.error) message = body.error;
    } catch {
      /* non-JSON error body — keep the generic message */
    }
    throw new Error(message);
  }

  return (await res.json()) as UploadedAttachment;
}
